import { pipe } from 'fp-ts/function';
import { array, number, option, ord } from 'fp-ts';
import { useMemo } from 'react';
import { GuestInHouseReportState, Service } from '@mews-commander/data-access';
import { useCommonDefaultFilterValues } from '../../../../common';
import { FilterValueKey } from '../types';
import { ReservationsTableColumns } from '../../common';

const byServiceOrdering: ord.Ord<Service> = pipe(
    number.Ord,
    ord.contramap(({ ordering }) => ordering)
);

const getDefaultServiceId = (services: Array<Service>) =>
    pipe(
        services,
        array.sort(byServiceOrdering),
        array.head,
        option.match(
            () => '',
            ({ id }) => id
        )
    );

interface UseDefaultFilterValuesParams {
    hasLoyaltyPrograms?: boolean;
    services: Array<Service>;
}

const defaultVisibleColumns = [
    ReservationsTableColumns.Classifications,
    ReservationsTableColumns.Notes,
    ReservationsTableColumns.Products,
];

export const useDefaultFilterValues = ({ hasLoyaltyPrograms, services }: UseDefaultFilterValuesParams) => {
    const defaultCommonValues = useCommonDefaultFilterValues();
    const defaultServiceId = useMemo(() => getDefaultServiceId(services), [services]);

    const defaultValues = {
        [FilterValueKey.serviceId]: defaultServiceId,
        [FilterValueKey.visibleColumns]: hasLoyaltyPrograms
            ? [ReservationsTableColumns.Loyalty, ...defaultVisibleColumns]
            : defaultVisibleColumns,
        [FilterValueKey.productIds]: [],
        [FilterValueKey.filterProductsInInterval]: false,
        [FilterValueKey.serviceOrderStatus]: [GuestInHouseReportState.CheckedIn],
    };

    return { ...defaultCommonValues, ...defaultValues };
};
